var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNotContacted = function SvgNotContacted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 338.954l-28.268-28.268-71.96 71.96-71.96-71.96-28.269 28.268 71.96 71.96-71.96 71.96 28.269 28.268 71.96-71.96 71.96 71.96L512 482.874l-71.96-71.96zM255.858.142C174.296.142 107.94 66.498 107.94 148.06c0 50.52 25.465 95.198 64.226 121.894-36.19 12.488-69.36 33.118-97.227 60.984C26.614 379.265 0 443.516 0 511.858h39.978c0-119.037 96.843-215.88 215.88-215.88 81.562 0 147.918-66.355 147.918-147.918C403.776 66.498 337.42.142 255.858.142zm0 255.858c-59.518 0-107.94-48.421-107.94-107.94S196.34 40.12 255.858 40.12s107.94 48.421 107.94 107.94S315.376 256 255.858 256z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotContacted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notContacted.657ecd9b.svg";
export { ForwardRef as ReactComponent };